// 旧ビルダープレビュー scene/util.ts から createOuterMesh を復元。
// キャラ/ジェムを intersectsMesh で当たり判定するため、可視 Box の親メッシュを作る。

import { Scene } from "@babylonjs/core/scene";
import { MeshBuilder } from "@babylonjs/core/Meshes/meshBuilder";
import { BoundingBox } from "@babylonjs/core/Culling/boundingBox";
import { Matrix, Vector3 } from "@babylonjs/core/Maths/math.vector";

export const createOuterMesh = (scene: Scene, boundingBox: BoundingBox, position: Vector3) => {
  const outer = MeshBuilder.CreateBox(
    "outer",
    {
      width: boundingBox.maximum.x - boundingBox.minimum.x,
      height: boundingBox.maximum.y - boundingBox.minimum.y,
      depth: boundingBox.maximum.z - boundingBox.minimum.z,
    },
    scene,
  );
  outer.isVisible = false;
  outer.isPickable = true;
  outer.checkCollisions = false;
  outer.showBoundingBox = false;
  outer.bakeTransformIntoVertices(
    Matrix.Translation(0, (boundingBox.maximum.y - boundingBox.minimum.y) / 2, 0),
  );
  outer.position = new Vector3().copyFrom(position);
  return outer;
};
